import React, { useState, useEffect } from 'react'

import { linkResolver } from '../../util/linkResolver'

import { PlayNextIcon } from '../Icons'
import TranscriptionLink from './TranscriptionLink'

import { RegionContainer } from '../styles/Utility.styles'

import * as Styled from './styles/PodcastBlock.styles'

const DEFAULT_PLAYER_HEIGHT = 90

const NextPodcastLink = ({ link }) => {
  const href = linkResolver(link)

  return (
    <Styled.NextPodcastLink to={href}>
      <span>Next Podcast</span>
      <PlayNextIcon />
    </Styled.NextPodcastLink>
  )
}

const PodcastBlock = ({ data }) => {
  const [playerHeight, setPlayerHeight] = useState(DEFAULT_PLAYER_HEIGHT)

  useEffect(() => {
    if (!data?.embed_code?.text) return

    const heightRegex = /height="(\d+)"/
    const match = data.embed_code.text.match(heightRegex)

    // Use a ternary operator to set heightValue
    const heightValue =
      match && match[1] ? parseInt(match[1], 10) : DEFAULT_PLAYER_HEIGHT
    setPlayerHeight(heightValue)
  }, [data.embed_code.text])

  return (
    <Styled.PodcastGreyFrame>
      <RegionContainer>
        <Styled.PodcastEmbedBlock
          playerHeight={playerHeight}
          dangerouslySetInnerHTML={{ __html: data.embed_code.text }}
        />
        <Styled.LinkRow>
          {data?.transcription_link && (
            <TranscriptionLink link={data.transcription_link} />
          )}
          {data?.next_podcast?.uid && (
            <NextPodcastLink link={data.next_podcast} />
          )}
        </Styled.LinkRow>
      </RegionContainer>
    </Styled.PodcastGreyFrame>
  )
}

export default PodcastBlock
